export default __webpack_public_path__ + "static/media/error404.6840d11c.svg";